import type { FC, ReactNode } from 'react'

import { Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { useTheme } from '@/components/generals/theme-provider'

export const ThemeToggle: FC = (): ReactNode => {
    const { resolvedTheme, toggleTheme } = useTheme()
    const isDark = resolvedTheme === 'dark'
    const label = isDark ? 'Gunakan mode terang' : 'Gunakan mode gelap'

    return (
        <Tooltip>
            <TooltipTrigger
                render={(
                    <Button
                        variant='ghost'
                        size='icon-lg'
                        onClick={toggleTheme}
                        aria-label={label}
                    />
                )}
            >
                {isDark ? <Sun className='size-[18px]' /> : <Moon className='size-[18px]' />}
            </TooltipTrigger>

            <TooltipContent side='bottom'>
                {label}
            </TooltipContent>
        </Tooltip>
    )
}
